export var TagEvent;
(function (TagEvent) {
    TagEvent["ON_READY"] = "TagEvent.ON_READY";
    TagEvent["ON_ONLINE"] = "TagEvent.ON_ONLINE";
    TagEvent["ON_OFFLINE"] = "TagEvent.ON_OFFLINE";
    TagEvent["ON_RESIZE"] = "TagEvent.ON_RESIZE";
    TagEvent["ON_MODEL_READY"] = "TagEvent.ON_MODEL_READY";
    TagEvent["ON_MODEL_FAILURE"] = "TagEvent.ON_MODEL_FAILURE";
    TagEvent["ON_VIEW_READY"] = "TagEvent.ON_VIEW_READY";
    TagEvent["ON_SESSION_START_IMPORTS_DONE"] = "TagEvent.ON_SESSION_START_IMPORTS_DONE";
    TagEvent["ON_IMPORTS_DONE"] = "TagEvent.ON_IMPORTS_DONE";
    TagEvent["ON_IMPORTS_FAILURE"] = "TagEvent.ON_IMPORTS_FAILURE";
    TagEvent["ON_METADATA_READY"] = "TagEvent.ON_METADATA_READY";
    TagEvent["ON_METADATA_FAILURE"] = "TagEvent.ON_METADATA_FAILURE";
    TagEvent["ON_PLAYER_EVENT"] = "TagEvent.ON_PLAYER_EVENT";
    TagEvent["ON_TAG_BEFORE_PLAYER_STOP_REQUEST"] = "TagEvent.ON_TAG_BEFORE_PLAYER_STOP_REQUEST";
    TagEvent["ON_TAG_PLAYER_STOP_REQUEST"] = "TagEvent.ON_TAG_PLAYER_STOP_REQUEST";
    TagEvent["ON_TAG_PLAYER_STOP_SUCCESS"] = "TagEvent.ON_TAG_PLAYER_STOP_SUCCESS";
    TagEvent["ON_TAG_PLAYER_STOP_FAILURE"] = "TagEvent.ON_TAG_PLAYER_STOP_FAILURE";
    TagEvent["ON_API_LOAD_PLAYER_STOP_REQUEST"] = "TagEvent.ON_API_LOAD_PLAYER_STOP_REQUEST";
    TagEvent["ON_API_LOAD_STOP_PLAYER_SUCCESS"] = "TagEvent.ON_API_LOAD_STOP_PLAYER_SUCCESS";
    TagEvent["ON_API_LOAD_VIDEO_REQUEST"] = "TagEvent.ON_API_LOAD_VIDEO_REQUEST";
    TagEvent["ON_API_RESET_TAG_REQUEST"] = "TagEvent.ON_API_RESET_TAG_REQUEST";
    TagEvent["ON_CUSTOM_SKIN_READY"] = "TagEvent.ON_CUSTOM_SKIN_READY";
    TagEvent["ON_CREATE_PLAYER_REQUEST"] = "TagEvent.ON_CREATE_PLAYER_REQUEST";
    TagEvent["ON_CREATE_PLAYER_SUCCESS"] = "TagEvent.ON_CREATE_PLAYER_SUCCESS";
    TagEvent["ON_CREATE_PLAYER_FAILURE"] = "TagEvent.ON_CREATE_PLAYER_FAILURE";
    TagEvent["ON_DESTROY_PLAYER_REQUEST"] = "TagEvent.ON_DESTROY_PLAYER_REQUEST";
    TagEvent["ON_DESTROY_PLAYER_SUCCESS"] = "TagEvent.ON_DESTROY_PLAYER_SUCCESS";
    TagEvent["ON_DESTROY_PLAYER_FAILURE"] = "TagEvent.ON_DESTROY_PLAYER_FAILURE";
    TagEvent["ON_REQUEST_RESOURCE_LOAD"] = "TagEvent.ON_REQUEST_RESOURCE_LOAD";
    TagEvent["ON_FATAL_ERROR"] = "TagEvent.ON_FATAL_ERROR";
    TagEvent["ON_AD_BLOCKER_DETECTED"] = "TagEvent.ON_AD_BLOCKER_DETECTED";
    TagEvent["ON_REQUEST_AD_BLOCKER_CHECK_STOP"] = "TagEvent.ON_REQUEST_AD_BLOCKER_CHECK_STOP";
    TagEvent["ON_REQUEST_TO_CLEAR_ERROR"] = "TagEvent.ON_REQUEST_TO_CLEAR_ERROR";
    TagEvent["ON_START_DEPENDENCIES_LOAD"] = "TagEvent.ON_START_DEPENDENCIES_LOAD";
    TagEvent["ON_PLAYER_HOOK_REQUEST_REGISTER"] = "TagEvent.ON_PLAYER_HOOK_REQUEST_REGISTER";
    TagEvent["ON_PLAYER_HOOK_REGISTERED"] = "TagEvent.ON_PLAYER_HOOK_REGISTERED";
    TagEvent["ON_PLAYER_HOOK_EXECUTED"] = "TagEvent.ON_PLAYER_HOOK_EXECUTED";
    TagEvent["ON_PLAYER_HOOK_REQUEST_REMOVE"] = "TagEvent.ON_PLAYER_HOOK_REQUEST_REMOVE";
    TagEvent["ON_PLAYER_HOOK_REMOVED"] = "TagEvent.ON_PLAYER_HOOK_REMOVED";
    TagEvent["ON_BEFORE_RESOURCE_LOAD"] = "TagEvent.ON_BEFORE_RESOURCE_LOAD";
})(TagEvent || (TagEvent = {}));
export const tagEvents = () => {
    const out = [];
    Object.keys(TagEvent).forEach((key) => {
        out.push(TagEvent[key]);
    });
    return out;
};
